/*
 * Helper for text formatting and encoding.
 */
define('core/txt', ['lib/underscore'], function (_) {

    /*
     * Matcher defines the base prototype for a pattern handler that our formatter will use to process a string.
     */
    function Matcher() {

        /*
         * RegEx identifying what pattern this Matcher can handle.
         */
        this.matchExp = '';
    };

    /*
     * Checks whether an expression can be handled.
     * Returns a processed string if the expression can be handled, otherwise null.
     */
    Matcher.prototype.tryMatch = function (exp, args) {
        if (exp.match(this.matchExp)) {
            return this.getResult(exp, args);
        }
        return null;
    };

    /*
     * Process an expression that matches our handler pattern and return the resultant string.
     */
    Matcher.prototype.getResult = function (exp, args) {
        return '';
    };

    /*
     * Matcher for normal text without special formatting characters.
     */
    function RegularMatcher() {
        this.matchExp = /^[^{}]/;
    }
    RegularMatcher.prototype = Object.create(Matcher.prototype);
    RegularMatcher.prototype.getResult = function (exp, args) {
        return exp;
    };

    /*
     * Matcher for escaped left braces, "{{" ==> "{".
     */
    function EscapedLeftBraceMatcher() {
        this.matchExp = /^{{/;
    }
    EscapedLeftBraceMatcher.prototype = Object.create(Matcher.prototype);
    EscapedLeftBraceMatcher.prototype.getResult = function (exp, args) {
        return '{';
    };

    /*
     * Matcher for escaped right braces, "}}" ==> "}".
     */
    function EscapedRightBraceMatcher() {
        this.matchExp = /^}}/;
    }
    EscapedRightBraceMatcher.prototype = Object.create(Matcher.prototype);
    EscapedRightBraceMatcher.prototype.getResult = function (exp, args) {
        return '}';
    };

    /*
     * Matcher for replacement sequences. The "args" param will be used to determine the result.
     * E.g. "{0}" ==> args[0]
     */
    function ReplacementMatcher() {
        this.matchExp = /^{\d+}/;
    }
    ReplacementMatcher.prototype = Object.create(Matcher.prototype);
    ReplacementMatcher.prototype.getResult = function (exp, args) {
        var index = exp.match(/\d+/)[0];
        return args[index] || '';
    };

    return {

        /*
         * Formats a string based on conventional rules:
         *   - Replacement sequences (e.g. "{0}") will be replaced based on passed in arguments
         *   - Braces can be escaped as "{{" ==> "{" and "}}" ==> "}"
         * Note: Invalid formats (e.g. "Hello }0") will result in truncated strings.
         * Usage: txt.format('{0}, {1}!', 'Hello', 'World');
         */
        format: function (format) {
            var args = Array.prototype.slice.call(arguments, 1);

            var matchers = [
                new RegularMatcher(),
                new EscapedLeftBraceMatcher(),
                new EscapedRightBraceMatcher(),
                new ReplacementMatcher(),
            ];

            var result = '';
            var currentExp = '';
            _.each(format, function (char) {
                currentExp += char;
                var partialResult = getMatch(currentExp);
                if (partialResult !== null) {
                    result += partialResult;
                    currentExp = '';
                }
            })

            return result;

            function getMatch(exp) {
                for (var i = 0; i < matchers.length; i++) {
                    var matchResult = matchers[i].tryMatch(exp, args)
                    if (matchResult !== null) {
                        return matchResult;
                    }
                }
                return null;
            }
        },

        /*
         * Returns the HTML-encoded version of the given string.
         */
        encode: function (str) {
            return $('<p>').text(str).html();
        },

        /*
         * Returns the HTML-decoded version of the given string.
         */
        decode: function (str) {
            return $('<p>').html(str).text();
        }
    }
});
